import { Fragment } from 'react';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const renderDependents = (dependents, path, passthroughProps, renderInput) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dependents.map(dependent => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        "data-test-id": `${path}-${dependent.property.name}`,
        children: renderInput ? renderInput(dependent) : dependent.render(passthroughProps)
      }), renderDependents(dependent.dependents, `${path}-${dependent.property.name}`, passthroughProps, renderInput)]
    }, `${path}-${dependent.property.name}`))
  });
};
function ConditionalPropertiesPanelDependentSection({
  input,
  passthroughProps,
  renderInput
}) {
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": `${input.property.name}-dependents`,
    borderStyle: "solid",
    borderWidth: "100",
    borderColor: "border-primary-subtle",
    borderInlineStartColor: "border-info-default",
    borderInlineStartWidth: "300",
    position: "relative",
    borderRadius: "100",
    marginBlockStart: "400",
    marginBlockEnd: "200",
    padding: "400",
    paddingBlockStart: "200",
    children: renderDependents(input.dependents, input.property.name, passthroughProps, renderInput)
  });
}
export default ConditionalPropertiesPanelDependentSection;